import Meta from "../../../components/meta/meta";
import {config} from "../../../config-merchant";
import HeaderAppyShop, {getComponentStaticProps, HeaderProps} from "../../../components/header/headerAppyShop";
import CustomerForm from "../../../components/customer/customerForm";
import FooterAppyShop from "../../../components/footer/footerAppyShop";
import React, {useEffect} from "react";
import {GetStaticProps} from "next";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {appyShopConfig} from "../../../config";
import {AxiosResponse} from "axios";
import {useRouter} from "next/router";
import {useTranslation} from "next-i18next";
import {Customer, ShopState} from "../../../interfaces/store-interfaces";
import {useSelector} from "react-redux";
import {areAddressEquals, getAddressOneLine} from "../../../utils/address";
import {updateAccount} from "../../../services/customer-services";

function UpdateAccount(props: {
    headerProps: HeaderProps,
}) {

    const {t} = useTranslation('common');
    const {i18n} = useTranslation('common')
    const router = useRouter();
    const customer: Customer = useSelector((state: ShopState) => state.customer);

    const updateCustomer = (values): Promise<AxiosResponse> => {
        if (values.password === "") {
            delete values.password;
        }
        return updateAccount(values, customer.jwt);
    }

    const redirectAfterSuccess = (): void => {
        if (router.isReady) {
            router.push("/my-account");
        }
    }

    useEffect(() => {
        if (customer === undefined) {
            router.push("/login");
        }
    }, [customer])

    return (
        <>
            <Meta
                title={t('MY_ACCOUNT_TITLE')}
                description={config.shopSlogan[i18n.language]}
                image={config.merchantDomain + config.defaultMetaImage}
                metaRobots={false}
            />
            <HeaderAppyShop headerProps={props.headerProps} activepage={'my-account'}/>
            <main>
                {customer !== undefined && customer !== null && <CustomerForm
                    initialValues={{
                        email: customer.email,
                        phoneNumber: customer.phone,
                        name: customer.defaultDeliveryAddress.name,
                        companyName: customer.defaultDeliveryAddress.companyName,
                        deliveryAddress: customer.defaultDeliveryAddress,
                        addressCompl: customer.defaultDeliveryAddress.complement,
                        deliveryAddressOneLine: getAddressOneLine(customer.defaultDeliveryAddress),
                        billingName: customer.defaultBillingAddress.name,
                        billingCompanyName: customer.defaultBillingAddress.companyName,
                        billingAddress: customer.defaultBillingAddress,
                        billingAddressOneLine: getAddressOneLine(customer.defaultBillingAddress),
                        sameAddress: areAddressEquals(customer.defaultDeliveryAddress, customer.defaultBillingAddress)
                    }}
                    onSubmit={updateCustomer}
                    onRedirect={redirectAfterSuccess}
                    isUpdate={true}
                />}
            </main>
            <FooterAppyShop/>
        </>
    );
}

export const getStaticProps: GetStaticProps = async ({locale}) => {
    if (config.menu.some(item => item.path === 'catalog') || config.footerLink.some(item => item.url === '/catalog')) {
        return {
            props: {
                ...await serverSideTranslations(locale, ['common']),
                headerProps: await getComponentStaticProps(locale)
            },
            revalidate: appyShopConfig.revalidateData
        }
    } else {
        return {
            notFound: true
        }
    }
}

export default UpdateAccount;
